import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import { useStore } from 'Store';

import { ActivityIndicator } from 'LocalGluons';
import VerifyCode from './VerifyCode';

const VerifyCodePassword = ({ onSubmitted, onGetHelp, data, navigation }) => {
    const { appManager } = useStore();
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const checkCode = async (code) => {
        const { loginOrNickname } = data;
        setLoading(true);
        try {
            await appManager.api.checkPasswordResetHash({
                loginOrNickname,
                code
            });
            onSubmitted({ code, loginOrNickname });
        } catch (error) {
            setErrorMessage(error.localizedMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <VerifyCode
                onSubmitted={checkCode}
                errorMessage={errorMessage}
                onGetHelp={onGetHelp}
                navigation={navigation}
            />
            {loading && <ActivityIndicator isOverlay />}
        </>
    );
};

VerifyCodePassword.propTypes = {
    data: shape({ login: string }).isRequired,
    onSubmitted: func.isRequired,
    onGetHelp: func.isRequired
};

export default VerifyCodePassword;
